// src/components/ConvertedPrice.tsx
import React from "react";
import { useConvertedPrice } from "../hooks/useConvertedPrice";

type Props = {
  price: number;
  baseCurrency?: string;
  forceRefresh?: boolean;
  // optional fallback if conversion fails
  fallback?: string;
  // optionally control how many decimals
  decimals?: number;
  // optional prefix/postfix formatting override (e.g. keep symbol at left or right)
  format?: (symbol: string | null, value: number | null) => string;
};

export default function ConvertedPrice({
  price,
  baseCurrency = "USD",
  forceRefresh = false,
  fallback,
  decimals = 2,
  format,
}: Props) {
  
  
  const { converted_price, symbol, loading, error } = useConvertedPrice(price, {
    baseCurrency,
    forceRefresh,
  });
  // console.log(converted_price, symbol, loading, error);
  // If user provided custom format function use it
  if (format) {
    return <>{format(symbol ?? null, converted_price ?? null)}</>;
  }

  // Loading state — show base currency with small loader
  if (loading) {
    // simple UI while waiting; adjust to your spinner/ux
    return <>{`${symbol ?? "$"}${converted_price ?? price}`}</>; // prefer symbol if already present else base $
  }

  // Error or no converted price → show fallback or base currency price
  if (error || converted_price === null || converted_price === undefined) {
    if (fallback) return <>{fallback}</>;
    // default fallback: show base currency price with $

    const fallbackPrice = price?.toFixed(decimals);
    return <>{`$${fallbackPrice}`}</>;
  }

  // Normal formatted value
  const fixed = Number(converted_price).toFixed(decimals);
  // show symbol + amount (if no symbol, show currency code or $)
  return <>{`${symbol ?? ""}${fixed}`}</>;
}
